import type { FeedEvent } from '../contract';
import { ArrowUpIcon, ArrowDownIcon, CheckIcon, AlertTriangleIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { EmptyState } from '../primitives/EmptyState';
import { InboxIcon } from 'lucide-react';
import { cn } from '../lib/cn';

const KIND: Record<FeedEvent['kind'], { icon: LucideIcon; chip: string }> = {
  gained: { icon: ArrowUpIcon, chip: 'bg-emerald-100 text-emerald-700' },
  lost: { icon: ArrowDownIcon, chip: 'bg-rose-100 text-rose-700' },
  completed: { icon: CheckIcon, chip: 'bg-blue-100 text-blue-700' },
  drifted: { icon: AlertTriangleIcon, chip: 'bg-amber-100 text-amber-700' },
};

/** Recent activity from the feed. Empty state is explicit, not a blank card. */
export function ActivityFeed({ feed }: { feed: FeedEvent[] }) {
  if (feed.length === 0) {
    return (
      <EmptyState
        icon={InboxIcon}
        title="Nothing has changed yet"
        description="Nothing has changed since your first check. As AI and Google update, the moves show up here."
      />
    );
  }
  return (
    <div className="flex flex-col">
      {feed.map((e) => {
        const { icon: Icon, chip } = KIND[e.kind];
        return (
          <div
            key={e.id}
            className="flex items-start gap-3 border-t border-gray-200 py-3 text-sm text-gray-700 first:border-t-0 first:pt-0"
          >
            <span className={cn('flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full', chip)}>
              <Icon className="h-3.5 w-3.5" />
            </span>
            <p className="min-w-0 flex-1">{e.plain}</p>
            <span className="flex-shrink-0 whitespace-nowrap text-xs text-gray-400">{e.at}</span>
          </div>
        );
      })}
    </div>
  );
}
